import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import defaultAvatar from '../assets/svg/images/default-avatar.jpg';

export default function ChatListItem({ chat, currentUserId, onClick }) {
  const recipient = chat.participants.find(id => id !== currentUserId);
  const lastMessage = chat.lastMessage || 'No messages yet';
  const unreadCount = chat.unreadCount?.[currentUserId] || 0;

  return (
    <div 
      className="flex items-center p-3 border-b border-gray-800 hover:bg-gray-900 cursor-pointer"
      onClick={onClick}
    >
      <div className="relative mr-3">
        <img
          src={chat.recipientPhotoURL || defaultAvatar}
          alt="Profile"
          className="w-12 h-12 rounded-full object-cover"
        />
        {chat.isOnline && (
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900"></div>
        )}
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center">
          <h3 className="font-medium truncate">{chat.recipientName || 'Unknown'}</h3>
          <span className="text-xs text-gray-400 ml-2 whitespace-nowrap">
            {chat.lastMessageTimestamp ? formatDistanceToNow(chat.lastMessageTimestamp.toDate(), { addSuffix: true }) : ''}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-sm text-gray-400 truncate">{lastMessage}</p>
          {unreadCount > 0 && (
            <span className="bg-green-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}